<div mat-dialog-title class="title-block">
  <div class="title-text">
    {{ data.title }}
  </div>
  <div class="close-icon" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </div>
</div>

<div mat-dialog-content>
  <p>{{ data.subtitle }}</p>
</div>
<div mat-dialog-actions>
  <button *ngIf="data.cancelBtnText"
          mat-button mat-dialog-close>
    {{ data.cancelBtnText | titlecase }}
  </button>
  <button *ngIf="data.okBtnText"
          mat-button mat-dialog-close
          (click)="onOkClick()">
    {{ data.okBtnText | titlecase }}
  </button>
  <button *ngIf="data.primaryBtn"
          mat-raised-button color="primary"
          (click)="onOkClick()">
    {{ data.primaryBtn }}
  </button>
</div>
